module.exports = __webpack_public_path__ + "static/media/user.ce5a46d0.svg";